export class UserClaim {
  constructor(
    public sub: string,
    public aud: string,
    public jti: string,
    public iss: string,
    public iat: number,
    public exp: number,
    public authTime: number,
    public displayName: string,
    public userType: string,
    public vmAccountId: string,
    public vmUserID: string,
    public vmHouseholdId: string,
    public piSri: string,
    public nonce: string,
    public sHash: string
  ) {}
}
